const tweenModule = require("@tweenjs/tween.js")

module.exports = {
  Tween: tweenModule.Tween,
  updateTween: tweenModule.update
}
